import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = (theme: ComposedTheme) => {
  return {
    wrap: {
      '&:hover, &:focus': {
        '& $menuButton': {
          opacity: 1,
        },
      },
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flex: 1,
      width: '100%',
    },
    displayName: {
      ...theme.grid.header.text.font,
      margin: 0,
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      flex: 1,
      padding: 0,
      color: theme.grid.header.text.color,
      textDecoration: 'none',
      textTransform: 'none',
      textAlign: 'left',
      display: 'flex',
      overflow: 'hidden',
      '& svg': {
        height: 12,
        width: 12,
        display: 'inline-block',
        marginRight: 4,
        fill: theme.grid.header.text.color,
      },
    },
    menuButton: {
      cursor: 'pointer',
      background: 'transparent',
      opacity: 0,
    },
    funnelWrap: {
      background: theme.palette.primary.darkBackground,
      borderRadius: '50%',
      height: 20,
      width: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': {
        height: 12,
        width: 12,
        fill: theme.palette.background,
      },
    },
    popover: {
      padding: [8, 14, 14],
      minWidth: 255,
    },
    textWrapper: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
};

export default createUseStyles(styles);
